export const getDateFormat = (precision) => {
    return precision === 'HOUR' ? 'MMM D, YYYY h:mm A' : 'MMM D, YYYY';
};
